export default {
      id: "icon-water-protection-usage",
      viewBox: "0 0 121.76 114.72",
      url: __webpack_public_path__ + "Assets/Sprite.svg#icon-water-protection",
      toString: function () {
        return this.url;
      }
    }